import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto";
import { Filial } from "app/components/movimentacao-estoque/MovimentacaoEstoque";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { ILotes } from "app/types/ILotes";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { LotesValidade } from "./lotesValidade";

export type LotesValidadeContainerProps = {
    item: IItemOrcamento,
    onVoltar: () => void,
    onRemover: () => void,
    passos: Dict<string,() => void>,
    foraOrcamento: boolean
};

export const LotesValidadeContainer = (props: LotesValidadeContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])

    const [dadosLotes, setDadosLotes] = useState<ILotes>();
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [filiais, setFiliais] = useState<Filial[]>()
    const [dadosLotesInicias, setDadosLotesIniciais] = useState<ILotes>({
        Lotes: undefined,
        QuantidadeBloqueadoVendaPagina: 0,
        QuantidadeDisponivelVendaPagina: 0,
        QuantidadeReservaLotePagina: 0,
        QuantidadeSaidaLotePagina: 0,
        Totais: {
            QuantidadeBloqueadoVenda: 0,
            QuantidadeDisponivelVenda: 0,
            QuantidadeReservaLote: 0,
            QuantidadeSaidaLote: 0,
            Transforming: false,
            UserMessage: false
        }
    })

    const dadosLotesIniciasRef = useRef(dadosLotesInicias)
    dadosLotesIniciasRef.current = dadosLotesInicias

    const valorParametro = useCallback((nome: string) => parametros.find((p) => p.Nome == nome)?.Valor, [parametros])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(passosInterno.current, props.onVoltar, props.item, props.foraOrcamento)

    const onVoltar = useCallback(() => {
        props.onRemover()
        props.onVoltar()
    }, [props.onRemover, props.onVoltar])

    const onPassoSelecionado = useCallback((passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }, [props.onRemover])

    const dadosLotesSemErros = useCallback((lotes: ILotes) => {
        setDadosLotes(lotes)
        setDadosLotesIniciais(lotes)
    }, [])

    const atualizarValoresParametros = useCallback(async () => {
        const resultado = await obterParametros({ nomes: ["CONTROLE_VALIDADE_PRODUTOS", "EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS", "APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO"] })
        if (!isMounted.current) return
        setParametros(resultado)
    }, [])

    const onObterDadosLotesProdutos = useCallback(async (numeroPagina?: number, filial?: string, voltar?: boolean) => {
        globalMU.blockUI();
        try {
            const lotes = await microuniversoApi.Produto.obterDadosLotesProdutoConsulta({
                CodigoProduto: props.item.Codigo,
                Filial: filial ?? null,
                NumeroPagina: numeroPagina ?? 1,
                TamanhoPagina: 20
            });
            if (!isMounted.current) return
            !("HasErrors" in lotes)
                ? dadosLotesSemErros(lotes)
                : (setDadosLotes({ ...dadosLotesIniciasRef.current, Lotes: undefined }), voltar && onVoltar())
        }
        catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e);
            filial == undefined && numeroPagina == undefined && onVoltar()
        }
        finally {
            globalMU.unblockUI();
        }
    }, [props.item.Codigo, dadosLotesSemErros, onVoltar])

    const onListarFiliais = useCallback(async () => {
        globalMU.blockUI();
        try {
            const dadosFiliais = await microuniversoApi.Produto.listarFiliais();
            if (!isMounted.current) return
            setFiliais(dadosFiliais)
        }
        catch (e) {
            if (!isMounted.current) return
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }, [])

    useEffect(() => {
        passosInterno.current.set(valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S" ? "Lotes/Validade" : "Lotes", () => { })
        atualizarValoresParametros()
        onObterDadosLotesProdutos(null, null, true)
        onListarFiliais()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="LotesValidadeContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />
            <LotesValidade
                produto={ props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != ""  ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao}
                dados={dadosLotes}
                filais={filiais}
                permiteVisualizarValidade={valorParametro("CONTROLE_VALIDADE_PRODUTOS") == "S"}
                exibeLocalFisicoConsultaProdutos={valorParametro("EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS") == "S" || valorParametro("APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO") == "S"}
                onPesquisarPorFilial={onObterDadosLotesProdutos}
                onPesquisarPaginado={onObterDadosLotesProdutos}
            />
        </>
    )
}
